import { emitRest, socketEmit } from 'lib/clients/socket';

// Stays registered for the life of the socket: the server answers `user-init` again after every
// reconnect, and that answer is what re-authenticates and re-emits the room joins (`emitRest`).
export default (response, sessionToken, sessionClientId) => {
  if (response?.ok) {
    socketEmit('user-auth', { token: sessionToken, sessionClientId });
    emitRest();
  }
};
